import I18n from 'I18n';
import once from 'transmute/once';
import * as ObjectSegConstants from '../../objectSeg/constants/constants';
import MissingField from '../../../filterQueryFormat/MissingField';
export default once(() => MissingField({
  name: ObjectSegConstants.MISSING_ASSOCIATION_BRANCH_FILTER,
  label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterMissingAssociationBranch.filterLabel')
}));